import { logger } from '@/pages/api/musicapp/_services/utils/apiLogger'

async function contentfulClient(
	query: string,
	functionName: string
): Promise<Response> {
	const isClientSide = typeof window !== 'undefined'
	!isClientSide &&
		logger.info('Contentful server-side request', {
			function: functionName,
		})

	return await fetch(
		`https://graphql.contentful.com/content/v1/spaces/${process.env.NEXT_PUBLIC_CONTENTFUL_SPACE_ID}/environments/${process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT}`,
		{
			method: 'POST',
			headers: {
				Authorization:
					'Bearer ' + process.env.NEXT_PUBLIC_CONTENTFUL_ACCESS_TOKEN,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				query: `{${query}}`,
			}),
		}
	)
}

export default contentfulClient
